import React, { useEffect, useState } from 'react'
import { NormalHeading, SmallHeading } from '../../../../Components/Utils/Heading';
import { BackButton, CancelButton, CreateButton, DownloadButton, EditButton } from '../../../../Components/Utils/Buttons';
import { Link, useLocation, useParams } from 'react-router-dom';
import Dashboard from '../../../../Components/Icons/Dasboard';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import axiosInstance from '../../../../Services/axiosCommon';
import NuDate from '../../../../Components/Utils/NuDate';
import Modal from '../../../../Components/Utils/AttachmentView';
import PdfLinkGrn from './Pdf/PdfLinkGrn';
import ViewPdf from './ViewPdf';
import ApprovalComponent from '../../../../Components/Utils/approvalComponent';
import GRNPdfOthers from '../../ViewPdfTemplate/GRNPdfOthers';
import GRNPdfNu from '../../ViewPdfTemplate/GRNPdfNu';
import PDFViewer from '../../../../Components/Utils/PDFViewer';
import FilesView from '../../../../Components/Utils/FilesView';
import RelatedGRNIndex from './RelatedGRNIndex';
import { GetAccess, GetRole } from '../../../../Components/Utils/roles';

function ViewGRN() {
  const { grnViewId } = useParams();

  const location = useLocation();
  const locationData = location.state?.data;
  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const [data, setData] = useState(locationData || null);

  useEffect(() => {
    if (!locationData && grnViewId) {
      axiosInstance
        .get(`/grn/${grnViewId}`)
        .then((res) => {
          setData(res.data?.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [grnViewId, locationData]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [filePathList, setFilePathList] = useState([]);
  const [showPdfComponent, setShowPdfComponent] = useState(false);
  const [isCommentsModalOpen, setIsCommentsModalOpen] = useState(false);
  const handleOpenCommentsModal = () => {
    setIsCommentsModalOpen(true);
  };

  const handleCloseCommentsModal = () => {
    setIsCommentsModalOpen(false);
  };
  useEffect(() => {
    if (
      data?.attachments &&
      data?.attachments !== "None" &&
      data?.attachments !== "[]"
    ) {
      setFilePathList(data?.attachments);
    }
  }, [data]);
  const [pdfLoading, setPdfLoading] = useState(false);
  const handlePdfIconClick = async () => {
    setShowPdfComponent(true);
    if (!viewPDF) {
      setPdfLoading(true);
      await ViewPDF();
      setPdfLoading(false);
    }
  };
  const closeFilterDialog = () => {
    setShowPdfComponent(false);
  };
  function UpdateAttachmentList(item) {
    let filterList = filePathList.filter((itemList) => itemList.file !== item);
    console.log('llll', filterList);
    setFilePathList(filterList);
  }

  function handleImageClick(img) {
    setSelectedImage(img);
    setIsModalOpen(true);
  }

  const id = grnViewId;
  const getUrl = `/grn/get-status`;
  const putUrl = `/grn/edit-status`;
  const statusUrl = '/grn/all-status';

  const downloadPDF = async () => {
    try {
      const response = await axiosInstance.get(`/grn/download-pdf/${grnViewId}`, {
        responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(pdfBlob);
      link.download = `${data?.ref || "grn"}.pdf`; // The filename you want for the downloaded file

      // Append the link to the body (required for Firefox)
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Clean up and remove the link
      link.parentNode.removeChild(link);

    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };


  const [viewPDF, setViewPDF] = useState(null);

  const ViewPDF = async () => {
    try {
      const response = await axiosInstance.get(`/grn/download-pdf/${grnViewId}`, {
        responseType: 'blob' // Important to specify the response type as blob
      });

      // Create a Blob from the response
      const pdfBlob = new Blob([response.data], { type: 'application/pdf' });

      // Create a link element
      let Viewlink = window.URL.createObjectURL(pdfBlob);
      setViewPDF(Viewlink);

    } catch (error) {
      console.error('Error downloading the PDF:', error);
    }
  };

  // Removed automatic PDF fetch on load - fetch only when user clicks PDF preview

  const EditAccess = "grn_edit"

  if (!data) {
    return (
      <div className="w-full h-[calc(100vh-125px)] flex items-center justify-center bg-white rounded-lg shadow-lg">
        <div className="flex flex-col items-center gap-2">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#579BB1]"></div>
          <p className="text-sm font-medium text-gray-500">Loading GRN details...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full py-2 px-4">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "GRN",
              link: "/store/grn"
            },
            { name: "View" },
          ]} />
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link to={'/store/grn'} state={{ currentPage: pageIndex, searchQuery: searchQuery != "" ? searchQuery : "" }}><BackButton link={true} /></Link>
          <DownloadButton handleClick={downloadPDF} label="Download as PDF" />
          {data?.editable === false ? (
            <>
              {GetRole() && (
                <Link to={`/store/grn/edit/${grnViewId}`}
                  state={{ data: data, from: `/store/grn/view/${grnViewId}`, pageIndex, searchQuery }}
                ><EditButton height='8' /></Link>
              )}
            </>
          ) : (
            <>
              {GetAccess(EditAccess) && (
                <Link to={`/store/grn/edit/${grnViewId}`}
                  state={{ data: data, from: `/store/grn/view/${grnViewId}`, pageIndex, searchQuery }}
                ><EditButton height='8' /></Link>
              )}
            </>
          )
          }
        </div>
      </div>
      <div className="w-full mx-auto min-h-[calc(100vh-125px)] h-auto lg:h-[calc(100vh-125px)] rounded-md overflow-y-auto lg:overflow-hidden p-1 sm:p-2 flex flex-col lg:flex-row gap-4 text-[#111537]">
        <div className="w-full lg:w-[70%] bg-white rounded-lg drop-shadow-lg py-1 flex flex-col overflow-hidden">
          <div className="w-[98%] bg-white px-2 mx-auto border border-gray py-2 rounded-lg flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 z-10">
            <div className="grid items-center">
              <div className="flex text-[14px] mb-1 text-[#111537] font-semibold">
                <p className="">{data?.ref}</p>
              </div>
              <div className="flex gap-4">
                <p className="text-xs text-[#111537]">Date : {data?.createdAt ? (
                  <NuDate value={data?.createdAt} format="DD-MMM-YYYY, hh:mm A" />
                ) : (
                  "N/A"
                )}
                </p>
              </div>
            </div>

            <div className="flex flex-row sm:flex-col items-center sm:items-end justify-between sm:justify-center gap-2">
              <div>
                <Link to={`/store/grn/viewIndex/${grnViewId}`} state={{ data: data, from: `/store/grn/view/${grnViewId}` }} >
                  <p className='text-xs cursor-pointer text-white bg-[#6A9C89] rounded-md inline-flex w-auto h-5 px-2 mr-1 sm:mr-3 flex-shrink-0 items-center justify-center'
                  >
                    GRN History
                  </p>
                </Link>
              </div>
              <div className="border rounded-md mr-1 sm:mr-3 border-[#579BB1] text-xs inline-flex w-auto flex-shrink-0 justify-center">
                <p className="bg-white text-black p-1 rounded-l-md">
                  Status </p><p className="bg-[#579BB1] text-white p-1 items-center rounded-r-md"> {data?.status || 'None'}</p>
              </div>
            </div>
          </div>
          <div className="h-auto lg:h-[calc(100vh-200px)] overflow-y-auto p-2 pb-8">

            <div className="w-full flex flex-wrap border border-gary mt-2 py-2 rounded-lg mb-2">

              <div className="w-full grid grid-cols-1 sm:grid-cols-2 gap-x-4 md:gap-x-8">
                <div className='w-full flex px-2'>
                  <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Deli. Notes</p>
                  <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.dnRef}</p>
                </div>
                <div className='w-full flex px-2'>
                  <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Busy GRN No.</p>
                  <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.busyGrnNo}</p>
                </div>
                <div className='w-full flex px-2'>
                  <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Recv. Date</p>
                  <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.receivedDate ? <NuDate value={data?.receivedDate} format="DD-MMM-YYYY hh:mm a" /> : '-'}</p>
                </div>


                {data && (
                  <>
                    {data?.approvedByName &&
                      <div className='w-full flex px-2'>
                        <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Approved By</p>
                        <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.approvedByName}</p>
                      </div>
                    }
                    {data?.reviewedByName &&
                      <div className='w-full flex px-2'>
                        <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Reviewed By</p>
                        <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.reviewedByName}</p>
                      </div>}
                    {data?.verifiedByName &&
                      <div className='w-full flex px-2'>
                        <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Verified By</p>
                        <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.verifiedByName}</p>
                      </div>}
                  </>
                )}

                <div className='w-full flex px-2'>
                  <p className='w-1/3 py-2 text-xs font-medium text-[#111537]'>Comments</p>
                  <p className='w-[65%] py-2 pl-2 text-xs text-[#606279]'>: {data?.comments}</p>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <div className="w-full sm:w-1/2">
                <p className="text-xs font-medium text-[#111537] p-1">
                  GRN Attachments
                </p>
                <div className="border border-gary overflow-y-scroll h-28 rounded-lg p-2">
                  <div className="w-full flex gap-2 items-center flex-wrap">
                    {data?.attachments &&
                      filePathList?.map((imgs, idx) => {
                        return (
                          <FilesView fileView={imgs} key={idx} />
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div className="w-full bg-white border border-gary mt-4 rounded-lg overflow-x-auto">
              <div className="min-w-[650px]">
                <div className="w-full py-2 bg-baseColor-primary flex justify-between rounded-lg px-2">
                  <p className="w-[5%] text-left text-white text-xs font-medium">S.N. </p>
                  <p className="w-[40%] text-left text-white text-xs font-medium">Product</p>
                  <p className="w-[10%] text-center text-white text-xs font-medium">Unit</p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">Ordered Qty</p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">Received Qty</p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">Remaining Qty</p>
                  <p className="w-[15%] text-center text-white text-xs font-medium">This Delivery</p>
                </div>
                {data?.products?.map((List, index) => {
                  return (
                    <div key={index} className="w-full py-2 flex justify-between odd:bg-white even:bg-slate-100 px-2">
                      <p className="w-[5%] text-left text-xs font-medium text-[#111537]">
                        {index + 1}
                      </p>
                      <p className="w-[40%] text-left text-xs font-medium text-[#111537]">
                        {List?.product_name}
                      </p>
                      <p className="w-[10%] text-center text-xs font-medium text-[#111537]">
                        {List?.product_unit}
                      </p>
                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        {List?.orderedQty}
                      </p>
                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        {List?.receivedQty}
                      </p>

                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        {List?.remainingQty}
                      </p>
                      <p className="w-[15%] text-center text-xs font-medium text-[#111537]">
                        {List?.thisDelivery}
                      </p>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-[30%] bg-white rounded-lg drop-shadow-lg py-1">
          <div className="h-[98%] overflow-y-scroll p-2 ">
            <ApprovalComponent id={id} getUrl={getUrl} putUrl={putUrl} statusUrl={statusUrl} refSetData={setData} data={data} type={"GRN"} preUrlName={"grn"} />

            <div className="w-full grid  border border-gary mt-4  rounded-lg">
              {/* <p className="text-xs text-[#111537] font-medium">Supplier Detail</p> */}
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                <p className="text-xs text-white font-medium">Customer Detail</p>

              </div>
              <div className='w-full flex px-2 justify-between'>
                <p className='w-[35%] py-2 text-xs font-medium text-[#111537]'>Supplier</p>
                <p className='w-[65%] py-2 text-xs  text-[#606279] truncate text-wrap'>: {data?.vendorName}</p>
              </div>
              <div className='w-full flex px-2 justify-between'>
                <p className='w-[35%] py-2 text-xs font-medium text-[#111537]'>PO</p>
                <p className='w-[65%] py-2  text-xs  text-[#606279] truncate'>: {data?.poRef}</p>
              </div>
              <div className="w-full flex px-2 justify-between">
                <p className="w-[35%] py-2 text-xs font-medium text-[#111537]">
                  YPR
                </p>
                <p className="w-[65%] py-2 text-xs font-medium text-[#606279] truncate">
                  <p>: {data?.prRef}</p>
                  <p className="pl-1.5"> {data?.prDate ? (
                    <NuDate
                      value={data?.prDate}
                      format="DD-MMM-YYYY, hh:mm A"
                    />
                  ) : (
                    " "
                  )}</p>
                </p>
              </div>

            </div>
            <div className="w-full grid  border border-gary mt-4  rounded-lg ">
              <p className="text-xs text-white font-medium bg-baseColor-primary  p-2 rounded-t-lg">Documents </p>
              <div className=" w-full flex flex-wrap overflow-y-scroll h-16">

                {/* <div onClick={handlePdfIconClick} className="cursor-pointer m-2   ">
          <svg
            width="30"
            height="30"
            fill="#048178"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
          </svg>
        </div> */}

                <div onClick={handlePdfIconClick} className="cursor-pointer m-1 w-auto h-[25px] flex items-center  justify-between  rounded p-[2px] border ">
                  <svg
                    width="20"
                    height="20"
                    fill="#048178"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 512 512"
                  >
                    <path d="M0 64C0 28.7 28.7 0 64 0L224 0l0 128c0 17.7 14.3 32 32 32l128 0 0 144-208 0c-35.3 0-64 28.7-64 64l0 144-48 0c-35.3 0-64-28.7-64-64L0 64zm384 64l-128 0L256 0 384 128zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
                  </svg>
                  <p className=' w-auto text-[10px]'>{data?.ref}</p>
                </div>

              </div>
            </div>
          </div>

        </div>
        <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        </Modal>
        {showPdfComponent && (
          <div className="fixed top-0 left-0 z-[9999] w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
            <div className="animate-scale-in relative w-[99%] h-[99%] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll flex flex-col">
              <button
                className="absolute top-2 right-2 text-white bg-red-600 rounded p-1 z-10"
                onClick={() => setShowPdfComponent(false)}
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              {pdfLoading ? (
                <div className="w-full h-full flex flex-col items-center justify-center gap-3">
                  <div className="w-8 h-8 border-4 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                  <p className="text-gray-600 font-medium text-sm">Loading GRN PDF preview...</p>
                </div>
              ) : (
                <PDFViewer pdfFile={viewPDF} />
              )}
            </div>
          </div>
        )}
      </div>
      {/* {isCommentsModalOpen && (
        <RelatedGRNIndex poId={data?.poId} close={handleCloseCommentsModal} grnId={grnViewId}/>
      )} */}
    </div>


  )
};

export default ViewGRN